import { BodyText } from '@policygenius/mortar';
import { FormRenderProps } from 'react-final-form';

import SelectField from 'components/formInputs/SelectField';
import FormWrapper from 'components/FormWrapper';
import InputRecommendationCard from 'components/InputRecommendationCard';
import { parseInteger } from 'forms/parsers';
import { InitialValues } from 'forms/types';

import { WAITING_PERIOD_LABEL, WAITING_PERIOD_OPTIONS } from './constants';
import { WaitingPeriodFormValues } from './types';
import { RECOMMENDATION_TEXT_1, RECOMMENDATION_TEXT_2, RECOMMENDATION_HEADING } from '../constants';

const WaitingPeriodForm: React.FC<
  FormRenderProps<WaitingPeriodFormValues, InitialValues<WaitingPeriodFormValues>>
> = ({ handleSubmit, invalid, submitting }) => (
  <FormWrapper handleSubmit={handleSubmit} invalid={invalid} submitting={submitting}>
    <InputRecommendationCard
      leftPaneBody={
        <SelectField
          label={WAITING_PERIOD_LABEL}
          name="waitingPeriod"
          options={WAITING_PERIOD_OPTIONS}
          config={{ parse: parseInteger }}
        />
      }
      rightPaneBody={
        <>
          <BodyText as="strong" weight="bold">
            {RECOMMENDATION_TEXT_1}
          </BodyText>{' '}
          <BodyText as="span">{RECOMMENDATION_TEXT_2}</BodyText>
        </>
      }
      rightPaneTitle={RECOMMENDATION_HEADING}
    />
  </FormWrapper>
);

export default WaitingPeriodForm;
